module.exports = __webpack_public_path__ + "static/jogadores-2e33d04dd4ea4f07ea0b7b07f338a3e9.jpg";